export const readonlyClass = "col-span-2 w-full px-2.5 py-1.5 text-sm border border-gray-200 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed";

export const editableClass = "col-span-2 w-full px-2.5 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500";

export const PAX_CONFIG = {
    total: {
        label: "Total pax",
        dot: "#6366F1",
        border: "#C7D2FE",
        bg: "#EEF2FF",
        modes: ["total"],
    },

    booked: {
        label: "Booked pax",
        dot: "#D97706",
        border: "#FCD34D",
        bg: "#FEF3C7",
        modes: ["total", "booked"],
    },

    confirmed: {
        label: "Confirmed pax",
        dot: "#16A34A",
        border: "#86EFAC",
        bg: "#DCFCE7",
        modes: ["total", "confirmed"],
    },

    arrived: {
        label: "Arrived pax",
        dot: "#2563EB",
        border: "#93C5FD",
        bg: "#DBEAFE",
        modes: ["total", "arrived"],
    },
};

export const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: "34px",
        height: "34px",
        fontSize: "0.875rem",
        borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
        boxShadow: "none",
        "&:hover": { borderColor: "#3b82f6" },
    }),

    valueContainer: (base) => ({
        ...base,
        padding: "0 6px",
        fontSize: "0.875rem",
    }),

    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        fontSize: "0.875rem",
    }),

    singleValue: (base) => ({
        ...base,
        fontSize: "0.875rem",
    }),

    placeholder: (base) => ({
        ...base,
        fontSize: "0.875rem",
    }),

    indicatorsContainer: (base) => ({
        ...base,
        height: "34px",
    }),

    dropdownIndicator: (base) => ({
        ...base,
        padding: "0 6px",
    }),

    clearIndicator: (base) => ({
        ...base,
        padding: "0 6px",
    }),

    menu: (base) => ({
        ...base,
        zIndex: 50,
        fontSize: "0.875rem",
    }),

    option: (base, { isFocused }) => ({
        ...base,
        fontSize: "0.875rem",
        backgroundColor: isFocused ? "#EFF6FF" : "white",
        color: "#111827",
    }),
};